module.exports = __webpack_public_path__ + "img/logo.ed4eedc9.png";